import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Typography } from '../typography'
import { ILinkProps, LinkSizeT } from './link.types'

export const LinkContainer = styled(Link)<{ $iconPosition: ILinkProps['iconPosition'] }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 6px;

  flex-direction: ${({ $iconPosition = 'right' }) => ($iconPosition === 'right' ? 'row' : 'row-reverse')};

  & svg {
    flex-shrink: 0;
  }
`

const sizeConfig: Record<LinkSizeT, string> = {
  base: '18px',
  lg: '24px',
}

export const LinkTypography = styled(Typography)<Pick<ILinkProps, 'size'>>`
  color: #2c72db;
  font-weight: 500;
  text-decoration-line: underline;

  font-size: ${({ size = 'base' }) => sizeConfig[size]};
`
